import { Dialog, DialogContent } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

type DialogWrapperProps = {
  isOpen: boolean;
  children: React.ReactNode;
  testId: string;
};

const useStyles = makeStyles()(() => ({
  contentContainer: {
    padding: '0px',
    paddingTop: '0px !important',
  },
}));

const DialogWrapper = ({ isOpen, children, testId }: DialogWrapperProps) => {
  const { classes } = useStyles();

  return (
    <Dialog test-id={testId} open={isOpen} fullScreen keepMounted>
      <DialogContent className={classes.contentContainer}>{children}</DialogContent>
    </Dialog>
  );
};

export default DialogWrapper;
